<mat-spinner *ngIf="loading"></mat-spinner>
<div *ngIf="!loading" class="edit-actions">
    <mat-spinner *ngIf="loadingAction" [diameter]="20"></mat-spinner>
    <button *ngIf="!loadingAction" matTooltip="Cancelar" (click)="cancel()" mat-icon-button class="card-inline">
    <mat-icon>clear</mat-icon>
    </button>
    <button *ngIf="!loadingAction && validDelivery" matTooltip="Imprimir" (click)="print()" mat-icon-button class="card-inline">
        <mat-icon>printer</mat-icon>
      </button>
        <button *ngIf="!loadingAction && validDelivery" matTooltip="Mail" (click)="sendMail()" mat-icon-button class="card-inline">
        <mat-icon>mail</mat-icon>
      </button>
    <button *ngIf="!loadingAction && validDelivery" matTooltip="Finalizar entrega" (click)="finish()" mat-icon-button class="card-inline">
      <mat-icon>done</mat-icon>
    </button>

</div>
<mat-tab-group (selectedIndexChange)="selectedIndexChange($event)" #tabGroup>
    <mat-tab label="Identificación">
        <div class="card-base  margin-botton-medium">
            <div class="card-content-wizard">
                <div class="card-container mat-elevation-z1">
                    <app-study-report-delivery-detail [hidden]="loading" #studyReportDeliveryIdentification></app-study-report-delivery-detail>
                </div>
            </div>
        </div>
    </mat-tab>
    <mat-tab label="Paciente">
        <div class="card-base  margin-botton-medium">
            <div class="card-content-wizard">
                <div class="card-container mat-elevation-z1">
                    <app-study-report-delivery-patient [hidden]="loading" #studyReportDeliveryPatient></app-study-report-delivery-patient>
                </div>
            </div>
        </div>
    </mat-tab>
</mat-tab-group>
